// extracted by mini-css-extract-plugin
module.exports = {"transfer":"transfer-3nxqq","transferLayover":"transferLayover-2mpwN"};